import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { DialogActions, DialogContent } from '@material-ui/core';

import { selectCurrentMasterSettings } from '@lib/selectors';
import { useSelector } from 'react-redux';
import { isUsingOutreachExperience } from 'embeds/UploadReferrals/utils';
import { DialogHeader, Button, Dialog, Typography } from 'embeds/components';

const styles = ({ spacing: { unit } }) => ({
  content: {
    padding: `${unit * 3}px !important`,
  },
});

const DialogReferralAccept = ({ classes, open, onCancel, onSubmit, totalReferrals }) => {
  const settings = useSelector(selectCurrentMasterSettings);
  const isToUseOutreachExperience = isUsingOutreachExperience(settings);
  return (
    <Dialog fullWidth maxWidth="sm" onClose={onCancel} open={open}>
      <DialogHeader onRequestClose={onCancel} title="Create Referrals" />
      <DialogContent className={classes.content}>
        <Typography variant="body1">
          {`You’re about to create ${totalReferrals} ${
            isToUseOutreachExperience ? 'outreach(es)' : 'referral(s)'
          }. Would you like to proceed?`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onCancel} variant="text">
          Cancel
        </Button>
        <Button type="button" variant="contained" color="primary" onClick={onSubmit}>
          Yes, create the {isToUseOutreachExperience ? 'outreaches' : 'referrals'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DialogReferralAccept.propTypes = {
  classes: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool,
  totalReferrals: PropTypes.number.isRequired,
};

export default withStyles(styles)(DialogReferralAccept);
